// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3iD4J","productName":"Table_productName__2j9nS"};